import { createReducer, on } from '@ngrx/store';
import { AdminAnnouncementState } from './admin-announcement.state';
import { adminAnnouncementStateInitial } from './admin-announcement.state.initial';
import { AdminAnnouncementActions } from './admin-announcement.actions';
import { AnnouncementEntitiesActions } from '../../../store/announcement-entities';

/**
 * Reducer für das Admin-Announcement Dashboard.
 */
export const adminAnnouncementReducers = createReducer(
  adminAnnouncementStateInitial,

  on(
    AdminAnnouncementActions.setPage,
    (state, { pageIndex, pageSize }): AdminAnnouncementState => ({
      ...state,
      pageIndex,
      pageSize,
    }),
  ),

  on(
    AdminAnnouncementActions.setSort,
    (state, { sortProperties, sortDirections }): AdminAnnouncementState => ({
      ...state,
      sortProperties,
      sortDirections,
      pageIndex: 0,
    }),
  ),

  on(
    AnnouncementEntitiesActions.loadListSuccess,
    (state, { announcements }): AdminAnnouncementState => ({
      ...state,
      displayedIds: announcements.map(a => a.id),
    }),
  ),

  on(
    AdminAnnouncementActions.openCreate,
    (state): AdminAnnouncementState => ({
      ...state,
      editorMode: 'create',
      editingAnnouncementId: null,
      saveError: null,
    }),
  ),

  on(
    AdminAnnouncementActions.openEdit,
    (state, { id }): AdminAnnouncementState => ({
      ...state,
      editorMode: 'edit',
      editingAnnouncementId: id,
      saveError: null,
    }),
  ),

  on(
    AdminAnnouncementActions.closeEditor,
    (state): AdminAnnouncementState => ({
      ...state,
      editorMode: null,
      editingAnnouncementId: null,
      isSaving: false,
      saveError: null,
    }),
  ),

  on(
    AdminAnnouncementActions.saveAsDraft,
    AdminAnnouncementActions.saveAndPublish,
    AdminAnnouncementActions.updateAnnouncement,
    (state): AdminAnnouncementState => ({
      ...state,
      isSaving: true,
      saveError: null,
    }),
  ),

  on(
    AdminAnnouncementActions.saveSuccess,
    (state): AdminAnnouncementState => ({
      ...state,
      isSaving: false,
      saveError: null,
    }),
  ),

  on(
    AdminAnnouncementActions.saveFailure,
    (state, { error }): AdminAnnouncementState => ({
      ...state,
      isSaving: false,
      saveError: error,
    }),
  ),
);
